import {BLOCKS} from '@contentful/rich-text-types';
import {LinkProp} from '@fo/shared-types';
import getIdNameFromLabel from './getIdNameFromLabel';

interface ContentfulAccordionProp {
  label: string;
}

export interface ContentEntry {
  nodeType: BLOCKS | string;
  content?: ContentEntryContent[];
  data: {
    target: {
      sys?: {
        accordion: {
          items: ContentfulAccordionProp[];
        };
      };
    };
  };
}

interface ContentEntryContent {
  value: string;
}

const getLinksFromContent = (content?: ContentEntry[]): LinkProp[] => {
  if (!content) {
    return [];
  }

  const acceptedHeadings: BLOCKS[] = [BLOCKS.HEADING_2];

  const links: LinkProp[] = content.reduce((acc: LinkProp[], entry: ContentEntry) => {
    if (acceptedHeadings.includes(entry.nodeType as BLOCKS) && entry.content && entry.content.length > 0) {
      const {value} = entry.content[0];

      // Sometimes the content contains a line break of an empty (or just a space) typed h2 or h3.
      // So we make it empty by removing all spaces first. And if it's empty, do not add it to the list.
      if (value.replace(/\s*/gm, '') === '') {
        return acc;
      }

      acc.push({
        label: value,
        href: getIdNameFromLabel(value),
      });
    }
    if (entry.nodeType === BLOCKS.EMBEDDED_ENTRY) {
      const items = entry.data.target?.sys?.accordion?.items;
      if (!items) {
        return acc;
      }
      items.forEach((subEntry: ContentfulAccordionProp) => {
        if (!subEntry.label) {
          return;
        }
        acc.push({
          label: subEntry.label,
          href: getIdNameFromLabel(subEntry.label),
        });
      }, []);
    }
    return acc;
  }, []);
  return links;
};

export default getLinksFromContent;
